export function getCookie(name: string) {
    const matches: any = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function getCookies() {
    const pairs: string[] = document.cookie.split(";")
    const cookies: any = {}
    for (let i=0; i<pairs.length; i++){
        const pair: string[] = pairs[i].split("=")
        cookies[(pair[0]+'').trim()] = pair.slice(1).join('=')
    }
    return cookies
}

export function setCookie(name: string, value: any, options: any = {}) {

    options = {
        path: '/',
        'expires': "Fri, 31 Dec 9999 23:59:59 GMT",
        ...options
    };
    
    if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
    }

    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

    for (const optionKey in options) {
        updatedCookie += "; " + optionKey;
        const optionValue = options[optionKey];
        if (optionValue !== true) {
            updatedCookie += "=" + optionValue;
        }
    }

    document.cookie = updatedCookie;
}

export const deleteCookie = (key: string, options?: any): void => {
    return setCookie(key, '', { ...options, maxAge: -1 });
};